export default {
  meta: {
    title: 'Locxx 租户跳转自测',
    url: '/dev/locxxtenantswitch',
    parentPath: ['/dev'],
    breadcrumbs: {
      path: ['/dev/locxxtenantswitch'],
      name: ['Locxx 租户跳转自测'],
    },
  },
};
